import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BrokervService } from './brokerv.service';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class SesionvService {

  loggedInv = false;
  sesionCookiev: any;
  infoCompletev: any;
  userv: any;
  cookieValue = null;
  //user: User = null;

  constructor(public cookieServicev: CookieService, public brokerv: BrokervService, public router: Router) { 
    this.getCookie();
  }

  validateCookie() {
    if (this.cookieValue) {
      this.validateSession();
    }
  }

  validateSession() {
    const data = {
      clientId: environment.oktaConfig.clientId,
      idSession: this.cookieServicev.get('IDSESSIONMDC'),
      country: environment.country
    };
    this.brokerv.validar_sesion(data).subscribe((resp: any) => {
      this.loggedInv = true;
      this.userv = resp;
    },
      (error) => {
        // this.cookieService.delete('IDSESSIONMDC', cookie, environment.domain);
      }
    );
  }

  closeSession() {
    if (this.sesionCookiev) {
      this.brokerv.cerrar_sesion( this.sesionCookiev ).subscribe( (resp: any) => {
        this.deleteCookie();
        this.loggedInv = false;
        this.sesionCookiev = null;
        this.router.navigate(['/']);
      },
        (error) => {
          this.loggedInv = false;
          this.deleteCookie();
          this.router.navigate(['/']);
        }
      );
    }
  }

  deleteCookie() {
    this.cookieServicev.delete('IDSESSIONMDC', '/', environment.domain);
  }

  getCookie() {
    this.sesionCookiev = this.cookieServicev.get('IDSESSIONMDC');
  }

  closeSessionWithoutCookie() {
    this.deleteCookie();
    this.loggedInv = false;
    this.cookieValue = null;
    this.router.navigate(['/']);
  }
}